export interface SendableCoinInfo {
  isLoading: boolean;
  hasCoinObjects: boolean;
  checkFailed: boolean;
  hasAddressBalance: boolean;
}

export function getSendDisabledReason(input: {
  balance: BigNumber.Value;
  coinInfo: SendableCoinInfo | undefined;
}): string | null {
  if (new BigNumber(input.balance).isLessThanOrEqualTo(0)) {
    return "You don't hold any of this asset.";
  }
  const coinInfo = input.coinInfo;
  if (!coinInfo || coinInfo.isLoading || coinInfo.hasCoinObjects) {
    return null;
  }
  if (coinInfo.checkFailed) {
    return "We couldn't check whether this balance can be sent. Try again.";
  }
  if (coinInfo.hasAddressBalance) return null;
  return 'This balance is not currently sendable (for example, staked SUI).';
}
import { BigNumber } from 'bignumber.js';
